module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[52]173.307b959.woff2";